import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form'
import { FormLayout, TextInput } from 'components/common'
import { SwitchField } from 'components/bundleProduct'
import CategoryImageField from './categoryImageField'
import { freshCategoryFormFields } from './utils'

const { NAME, EXCLUDED_BARCODES, IS_ACTIVE } = freshCategoryFormFields

type FreshCategoryFormProps = {
  register: UseFormRegister<any>
  control: Control<any>
  setValue: UseFormSetValue<any>
  errors: FieldErrors<any>
  // The saved category on the edit page
  category?: any
  onUploadingChange: (isUploading: boolean) => void
}

const FreshCategoryForm = ({
  register,
  control,
  setValue,
  errors,
  category,
  onUploadingChange,
}: FreshCategoryFormProps) => {
  return (
    <>
      <h3 className="title">Category Details</h3>

      <FormLayout>
        <div className="grid gap-x-5 gap-y-3 md:grid-cols-2">
          <TextInput
            required
            label={NAME.label}
            register={register}
            name={NAME.key}
            error={errors?.[NAME.key]?.message as string}
          />

          <div className="md:col-span-2">
            <TextInput
              label={EXCLUDED_BARCODES.label}
              register={register}
              name={EXCLUDED_BARCODES.key}
              placeholder="e.g. 9807108000000, 9807109000000"
              hintText="Comma-separated barcodes assigned to this category to leave out of it"
              error={errors?.[EXCLUDED_BARCODES.key]?.message as string}
            />
          </div>

          <CategoryImageField
            setValue={setValue}
            defaultKey={category?.image}
            defaultUrl={category?.imageUrl}
            onUploadingChange={onUploadingChange}
          />

          <div>
            <SwitchField
              control={control}
              name={IS_ACTIVE.key}
              label={IS_ACTIVE.label}
              description="Inactive hides the category from the Fresh mobile app but keeps every user assignment"
              defaultValue={category?.[IS_ACTIVE.key] ?? true}
              showStatusPill
            />
          </div>
        </div>
      </FormLayout>
    </>
  )
}

export default FreshCategoryForm
